var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayAgain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "restart_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.197,
    height: 137.197,
    viewBox: "0 0 137.197 137.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M0,0H137.2V137.2H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(22.866 14.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M15.433,62.524A34.181,34.181,0,0,1,25.494,38.286l-8.117-8.117a45.728,45.728,0,0,0,26.639,77.688V96.308A34.338,34.338,0,0,1,15.433,62.524Zm80.032,0A45.72,45.72,0,0,0,49.732,16.791c-.343,0-.686.057-1.029.057l6.231-6.231L46.874,2.5,26.866,22.508,46.874,42.516l8.06-8.06L48.76,28.282c.343,0,.686-.057.972-.057a34.28,34.28,0,0,1,5.717,68.084v11.547A45.666,45.666,0,0,0,95.465,62.524Z",
    transform: "translate(-4 -2.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAgain);
export default __webpack_public_path__ + "static/media/play-again.5cb7461a.svg";
export { ForwardRef as ReactComponent };